import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _classCallCheck from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _difference from "lodash/difference";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.object.values.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue"; // @ts-ignore
// import _ from "lodash";

import MatImage from "./MatImage.vue";
import Leaf from "vue-material-design-icons/Leaf.vue";
import KitDialog from "./KitDialog.vue";

var Colori = /*#__PURE__*/function (_Vue) {
  _inherits(Colori, _Vue);

  var _super = _createSuper(Colori);

  function Colori() {
    var _this;

    _classCallCheck(this, Colori);

    _this = _super.apply(this, arguments);
    _this.findColor = "";
    _this.findEcoColor = ""; // finitura: String = "";

    _this.filtroColori = "";
    _this.category = [];
    _this.categories = [];
    _this.noImageColor = [];
    _this.filtriColori = [{
      nome: "pink",
      max: 345,
      min: 300,
      style: {
        background: "#ff00ff"
      }
    }, {
      nome: "purple",
      max: 299,
      min: 239,
      style: {
        background: "#8000ff"
      }
    }, {
      nome: "blue",
      max: 238,
      min: 190,
      style: {
        background: "#0000ff"
      }
    }, {
      nome: "green",
      max: 189,
      min: 75,
      style: {
        background: "#00ff00"
      }
    }, {
      nome: "yellow",
      max: 74,
      min: 48,
      //background:'#ffff00',
      style: {
        background: "#ffff00"
      }
    }, {
      nome: "orange",
      max: 47,
      min: 14,
      style: {
        background: "#ff8000"
      }
    }, {
      nome: "red",
      max: 13,
      min: 0,
      style: {
        background: "#ff0000"
      }
    }, {
      nome: "black&white",
      max: -1,
      min: -2,
      style: {
        background: "linear-gradient(to bottom right, #FFFFFF 50%, #000000 50%)"
      }
    }];
    return _this;
  }

  _createClass(Colori, [{
    key: "tintaUnita",
    get: function get() {
      return this.$store.state.tintaUnita;
    },
    set: function set(newVal) {
      this.$store.commit("setTintaUnita", newVal);
    }
  }, {
    key: "frontModel",
    get: function get() {
      return this.$store.state.configurator.frontale.U_THE_MODELLO.replace(/([0-9]+)(S)/i, "$1");
    }
  }, {
    key: "frontale",
    get: function get() {
      return this.$store.state.configurator.frontale;
    }
  }, {
    key: "colore",
    get: function get() {
      return this.$store.state.configurator.colore;
    }
  }, {
    key: "coloreAste",
    get: function get() {
      return this.$store.state.configurator.coloreAste;
    }
  }, {
    key: "colori",
    get: function get() {
      return this.$store.state.configurator.frontali.colors;
    }
  }, {
    key: "filteredColors",
    get: function get() {
      var _this2 = this;

      var q = this.findColor;
      var c = this.category;
      var f = this.filtroColori;
      var result = this.colori;
      var ec = this.findEcoColor;

      if (q) {
        result = result.filter(function (color) {
          return color.PLASTICA.indexOf(q) > -1;
        });
      }

      if (c.length > 0) {
        if (result) {
          result = result.filter(function (color) {
            return c.indexOf(color.Category) >= 0;
          });
        }
      }

      if (f != "") {
        result = result.filter(function (color) {
          return color.Order <= f.max && color.Order >= f.min;
        });
      }

      if (ec != "") {
        result = result.filter(function (color) {
          return color.PLASTICA.indexOf(ec) > -1;
        });
      }

      if (this.$store.state.affogatiEnabled && this.tintaUnita) {
        // Seleziona solo i colori che hanno un corrispettivo tra le aste
        result = result.filter(function (color) {
          return _this2.temples.findIndex(function (temple) {
            return temple.U_THE_COLORE == color.U_THE_COLORE && temple.misura == (_this2.coloreAste ? _this2.coloreAste.U_THE_LUNGASTA : "145");
          }) != -1;
        });
      }

      return _difference(result, this.noImageColor);
    }
  }, {
    key: "temples",
    get: function get() {
      if (this.$store.state.affogatiEnabled) {
        var height = this.getLastNumberFromString(this.frontale.ModelName);

        var _aste = this.$store.state.mappedTempleColors.get(height);

        this.$store.state.cachedAsteAffogati = _aste;
        return _aste;
      }

      if (this.$store.state.cachedAsteNonAffogati.length > 0) {
        return this.$store.state.cachedAsteNonAffogati;
      }

      var aste = this.$store.state.configurator.aste.allColors.filter(function (a) {
        var _a$U_THE_MODELLO, _a$U_THE_MODELLO2;

        return !((_a$U_THE_MODELLO = a.U_THE_MODELLO) !== null && _a$U_THE_MODELLO !== void 0 && _a$U_THE_MODELLO.includes("7.5F")) && !((_a$U_THE_MODELLO2 = a.U_THE_MODELLO) !== null && _a$U_THE_MODELLO2 !== void 0 && _a$U_THE_MODELLO2.includes("12F"));
      });
      this.$store.state.cachedAsteNonAffogati = aste;
      return aste;
    }
  }, {
    key: "isGuest",
    get: function get() {
      return this.$store.getters["configurator/user/isGuest"];
    }
  }, {
    key: "isSuperUser",
    get: function get() {
      return this.$store.state.configurator.user.user.isSuperUser;
    }
  }, {
    key: "finitura",
    get: function get() {
      return this.$store.state.configurator.finitura;
    },
    set: function set(f) {
      var _this3 = this;

      this.$store.commit("configurator/setFinishing", f);

      if (this.$store.state.affogatiEnabled) {
        var corresponding = this.temples.find(function (temple) {
          return temple.U_THE_COLORE == _this3.coloreAste.U_THE_COLORE && temple.misura == _this3.coloreAste.U_THE_LUNGASTA;
        });

        if (corresponding) {
          this.$store.commit("configurator/setTemplesColor", corresponding);
          this.$store.commit("configurator/setTemplesFinishing", f);
        }
      }
    }
  }, {
    key: "setColore",
    value: function setColore(c) {
      var _this4 = this;

      if (this.$store.state.affogatiEnabled) {
        var corresponding = this.temples.find(function (temple) {
          return temple.U_THE_COLORE == (_this4.tintaUnita ? c.U_THE_COLORE : _this4.coloreAste.U_THE_COLORE) && temple.misura == (_this4.coloreAste ? _this4.coloreAste.U_THE_LUNGASTA : "145");
        });

        if (corresponding) {
          this.$store.commit("configurator/setTemplesColor", corresponding);
          this.$store.commit("configurator/setTemplesFinishing", this.finitura);
        }
      }

      if (parseInt(c.GiacIta) < 1) {
        _Message({
          showClose: true,
          message: this.$t('message.Il_colore_{color}_è_esaurito,_data_di_arrivo:_{date}', {
            color: c.U_THE_COLORE,
            date: this.formatDate(new Date(c.ShipDateIta))
          }).toString(),
          type: "error",
          duration: 10000
        });
      }

      this.$store.commit("configurator/setColore", c);
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var day = String(date.getDate()).padStart(2, '0');
      var month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero based

      var year = date.getFullYear();
      return "".concat(day, "/").concat(month, "/").concat(year);
    }
  }, {
    key: "getLastNumberFromString",
    value: function getLastNumberFromString(inputString) {
      // Define a regular expression pattern to match numbers at the end of the string
      var pattern = /(\d{1,3}(?:[.,]\d{3})*(?:[.,]\d+)?)(?=\D*$|$)/; // Use the match method to find the number

      var match = inputString.match(pattern); // Check if a match was found

      if (match) {
        // Extract the matched number and replace commas with periods
        var matchedNumber = match[0].replace(",", "."); // Parse the number as a float

        var parsedNumber = parseFloat(matchedNumber);
        return parsedNumber;
      } // If no match was found, return NaN or handle it as needed


      return NaN;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this5 = this;

      // @ts-ignore
      this.$rest.getColorsCategories().then(function (response) {
        var d = response.data;
        _this5.categories = Object.values(d);
      }); // console.log(
      //   this.$store.state.configurator.frontale.U_THE_MODELLO.replace(
      //     /([0-9]+)(S)/i,
      //     "$1"
      //   )
      // );
    }
  }]);

  return Colori;
}(Vue);

Colori = __decorate([Component({
  components: {
    MatImage: MatImage,
    Leaf: Leaf,
    KitDialog: KitDialog
  }
})], Colori);
export default Colori;